import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Star, ArrowLeft, ArrowRight, Quote } from "lucide-react";
import { REVIEWS } from "../../lib/data";

export const Reviews = () => {
  const [index, setIndex] = useState(0);
  const review = REVIEWS[index];

  const next = () => setIndex((i) => (i + 1) % REVIEWS.length);
  const prev = () => setIndex((i) => (i - 1 + REVIEWS.length) % REVIEWS.length);

  return (
    <section
      id="reviews"
      data-testid="reviews"
      className="relative border-t border-white/10 py-28 md:py-40"
    >
      <div className="mx-auto max-w-[90rem] px-6 md:px-12">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-white/65">
              / What founders say when the ads are off
            </p>
            <h2 className="mt-4 max-w-2xl font-display text-4xl font-extrabold leading-none tracking-tighter text-white md:text-6xl">
              Numbers move.{" "}
              <span className="font-serif-emph font-normal">Founders talk.</span>
            </h2>
          </div>
          <div className="flex gap-3">
            <button
              onClick={prev}
              data-testid="review-prev"
              className="flex h-12 w-12 items-center justify-center rounded-full border border-white/15 text-white transition-colors hover:bg-white/5"
              aria-label="Previous review"
            >
              <ArrowLeft size={18} />
            </button>
            <button
              onClick={next}
              data-testid="review-next"
              className="flex h-12 w-12 items-center justify-center rounded-full border border-white/15 text-white transition-colors hover:bg-white/5"
              aria-label="Next review"
            >
              <ArrowRight size={18} />
            </button>
          </div>
        </div>

        <div className="mt-14 grid gap-10 md:grid-cols-12 md:items-center">
          <AnimatePresence mode="wait">
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
              className="md:col-span-8"
              data-testid="review-card"
            >
              <Quote size={56} className="text-white/35" />
              <blockquote className="mt-6 font-display text-2xl font-medium leading-snug tracking-tight text-white md:text-4xl">
                “{review.text}”
              </blockquote>
              <div className="mt-8 flex items-center gap-4">
                <img
                  src={review.img}
                  alt={review.name}
                  className="h-14 w-14 rounded-full object-cover ring-2 ring-white/40"
                />
                <div>
                  <p className="font-semibold text-white">{review.name}</p>
                  <p className="text-sm text-white/75">
                    {review.role} · {review.location}
                  </p>
                </div>
                <div className="ml-auto hidden items-center gap-1 sm:flex">
                  {[...Array(review.rating)].map((_, i) => (
                    <Star key={i} size={16} className="fill-white text-white" />
                  ))}
                </div>
              </div>
            </motion.div>
          </AnimatePresence>

          <div className="md:col-span-4 md:border-l md:border-white/10 md:pl-8">
            <div className="space-y-2">
              {REVIEWS.map((r, i) => (
                <button
                  key={r.name}
                  onClick={() => setIndex(i)}
                  data-testid={`review-dot-${i}`}
                  className={`block w-full text-left transition-colors ${
                    i === index ? "text-white" : "text-white/70 hover:text-white/75"
                  }`}
                >
                  <span className="font-mono text-xs">{String(i + 1).padStart(2, "0")}</span>{" "}
                  <span className="font-display text-lg font-bold tracking-tight">
                    {r.name}
                  </span>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Reviews;
